import { Pagination } from '@/api/pagination';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AxiosObservable } from 'axios-observable/dist/axios-observable.interface';
import { TipoPedidoAPI } from '@/api/tipo-pedido.api';
import { PageTipoPedidoInput, TipoPedido } from '@/models/tipo-pedido';

const api = new TipoPedidoAPI();

const list = (params: any): Observable<any> => {
  return api.list(params);
}

const show = (id: number): AxiosObservable<TipoPedido> => {
  return api.show(id);
}

const create = (solicitationType: any): AxiosObservable<TipoPedido> => {
  const body = {
    name: solicitationType.name,
    key: solicitationType.key,
    value: solicitationType.value,
  };

  return api.create(body)
}

const update = (id: number, solicitationType: any): AxiosObservable<TipoPedido> => {
  const body = {
    name: solicitationType.name,
    key: solicitationType.key,
    value: solicitationType.value,
  };

  return api.update(id, body)
}

const remove = (id: number): AxiosObservable<any> => {
  return api.delete(id)
}

const addDocumentType = (solicitationTypeId: number, documentTypeId: number): AxiosObservable<any> => {
  const body = { type_solicitation_type_document: { type_document_id: documentTypeId } };

  return api.addDocumentType(solicitationTypeId, body);
}

const listDocumentTypes = (solicitationTypeId: number, params: any): AxiosObservable<any> => {
  return api.listDocumentTypes(solicitationTypeId, params);
}

const removeDocumentType = (solicitationTypeId: number, documentTypeId: number): AxiosObservable<any> => {
  return api.removeDocumentType(solicitationTypeId, documentTypeId);
}

export default {
  list,
  show,
  create,
  update,
  remove,
  addDocumentType,
  removeDocumentType,
  listDocumentTypes
}
